import { PolicyCharacteristics } from '../../../types/policy';
import { getCharacteristicAtTime_T_ } from '../../../util/util';
import { FormBuilder, FormShape, PolicyFormTransformer } from '../types';

const getQuotePolicyForm = (
	props: PolicyFormTransformer,
	name = 'policyForm' as keyof FormShape<FormBuilder>,
) => {
	const { policyData } = props;
	const { productConfig, selectedQuote, policy, policyViewTimestamp } =
		policyData;
	const { policyConfiguration } = productConfig;
	let characteristics = policy.characteristics.filter(
		(pc) => !pc.replacedTimestamp,
	)[0];
	if (policy.issuedTimestamp) {
		characteristics = getCharacteristicAtTime_T_(
			policy.characteristics,
			parseInt(policyViewTimestamp, 10),
		) as PolicyCharacteristics;
	} else {
		// Do we need this?
		characteristics = selectedQuote.characteristics;
	}
	const { fieldValues, fieldGroupsByLocator, mediaByLocator } = characteristics;
	const { fields, externalDataCalls } = policyConfiguration;
	return {
		[name]: {
			fields,
			fieldGroupsByLocator,
			mediaByLocator,
			externalDataCalls,
			values: fieldValues,
		} as FormBuilder,
	} as FormShape<FormBuilder>;
};

export default getQuotePolicyForm;
